import { API_BASE_URL, fetchWithTimeout } from "@/config/apiBase";
import {
  clearAuthStorage,
  persistAuthSession,
  useSessionCookie,
} from "@/config/session";

let loginGraceUntil = 0;

export function markLoginGracePeriod(ms = 8000) {
  loginGraceUntil = Date.now() + ms;
}

export function isLoginGracePeriod() {
  return Date.now() < loginGraceUntil;
}

/** After login: prefer HttpOnly cookie; fall back to Bearer if cookie is not accepted. */
export async function establishSessionAfterLogin(user, token) {
  if (!user?.userId) {
    throw new Error("Invalid login response.");
  }

  if (!useSessionCookie()) {
    persistAuthSession(user, token);
    markLoginGracePeriod();
    return "bearer";
  }

  persistAuthSession(user, null, { cookieOnly: true });
  markLoginGracePeriod();

  let meRes = await fetchWithTimeout(`${API_BASE_URL}/api/auth/me`);
  if (meRes.ok) {
    return "cookie";
  }

  if (token) {
    persistAuthSession(user, token, { bearerFallback: true });
    meRes = await fetchWithTimeout(`${API_BASE_URL}/api/auth/me`);
    if (meRes.ok) {
      return "bearer-fallback";
    }
  }

  clearAuthStorage();
  throw new Error(
    "Session could not be established. Ensure backend and frontend are both updated, then try again."
  );
}
